import { formatCurrency } from '@/utils/formatters';

/** Whole units only: the matrix has no room for cents. */
export const formatMatrixAmount = (
  amount: number,
  currency: string,
  currencySign: Intl.NumberFormatOptions['currencySign'] = 'standard'
): string =>
  formatCurrency(amount, {
    currency,
    currencySign,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
